// Extend window interface for ENV_CONFIG
declare global {
  interface Window {
    ENV_CONFIG?: {
      VITE_API_URL?: string;
      VITE_API_PASSWORD?: string;
      VITE_ENABLE_SOURCE_ATTRIBUTION?: string;
    };
  }
}

// Dynamic configuration that works in both Docker and standalone
const getApiUrl = () => {
  // Check for runtime injected config (Docker production)
  if (window.ENV_CONFIG?.VITE_API_URL) {
    return window.ENV_CONFIG.VITE_API_URL;
  }
  
  // Development environment
  if (import.meta.env.DEV) {
    // Docker development: backend is on host machine
    return import.meta.env.VITE_API_URL || 'http://localhost:8000';
  }
  
  // Production build default
  return import.meta.env.VITE_API_URL || '/api';
};

const API_BASE_URL = getApiUrl();

export const API_CONFIG = {
  BASE_URL: API_BASE_URL,
  ENABLE_SOURCE_ATTRIBUTION: window.ENV_CONFIG?.VITE_ENABLE_SOURCE_ATTRIBUTION !== 'false' &&
                             import.meta.env.VITE_ENABLE_SOURCE_ATTRIBUTION !== 'false',
  REQUEST_TIMEOUT: 30000,
  VDB_REBUILD_TIMEOUT: 300000,
  RETRY_ATTEMPTS: 3
} as const;